var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClariCopilot({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.622 6.72l-6.09 1.655c.246 1.143.376 2.354.376 3.626 0 1.27-.131 2.481-.377 3.625l6.091 1.655c.39-1.65.595-3.46.595-5.28 0-1.82-.205-3.63-.595-5.28z",
    fill: "#00D7B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.199 5.01L2.184 12 8.538 7.23a7.237 7.237 0 00-2.34-2.22zM6.199 18.99L2.184 12l6.354 4.768a7.228 7.228 0 01-2.34 2.222z",
    fill: "#5F3AD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.524 3.491l-11.34 8.51 13.348-3.626c-.39-1.814-1.075-3.457-2.008-4.884z",
    fill: "#0280FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.524 20.509l-11.34-8.51 13.348 3.626c-.39 1.815-1.075 3.458-2.008 4.884z",
    fill: "#0280FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.909 12c0-1.272-.13-2.482-.376-3.626l-13.35 3.625 13.349 3.626A17.12 17.12 0 0015.909 12z",
    fill: "#fff"
  })));
}

export default SvgClariCopilot;